import { dateUtil } from "@sdeapps/react-core";
import type { Mandat } from "models";
import type { MandatSdeaFormModel } from "pages/Elu/models/Mandat";

function getMandatForCompareFromFormModel(formModel: MandatSdeaFormModel, mandat: Mandat): Mandat {
  return {
    ...mandat,
    dateDebutMandat: dateUtil.format(formModel.dateDebutMandat, "yyyy-MM-dd"),
    dateFinMandat:
      formModel.dateFinMandat == null
        ? undefined
        : dateUtil.format(formModel.dateFinMandat, "yyyy-MM-dd"),
    // @ts-expect-error: competence peut en fait être égal à "" dans le formulaire
    competence: formModel.competence === "" ? undefined : formModel.competence,
    codeCollectivite: formModel.commune?.id ?? undefined,
    libelleCollectivite: formModel.commune?.libelle ?? undefined,
    idTerritoire: formModel.territoire?.id ?? undefined,
    libelleTerritoire: formModel.territoire?.libelle ?? undefined,
    idPerimetre: formModel.perimetre?.id ?? undefined,
    libellePerimetre: formModel.perimetre?.libelle ?? undefined,
  };
}

export const mandatsUtil = {
  getMandatForCompareFromFormModel,
};
